import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

interface ExplorerLinks {
  [key: string]: {
    address: string;
    tx: string;
  };
}

@Injectable()
export class ExplorerLinkerService {
  private links: ExplorerLinks = {
    edg: {
      address: 'https://etherscan.io/address/{address}',
      tx: 'https://etherscan.io/tx/{txHash}',
    },
    eth: {
      address: 'https://etherscan.io/address/{address}',
      tx: 'https://etherscan.io/tx/{txHash}',
    },
    btc: {
      address: 'https://www.blockchain.com/btc/address/{address}',
      tx: 'https://www.blockchain.com/btc/tx/{txHash}',
    },
    bch: {
      address: 'https://www.blockchain.com/bch/address/{address}',
      tx: 'https://www.blockchain.com/bch/tx/{txHash}',
    },
    ltc: {
      address: 'https://live.blockcypher.com/ltc/address/{address}',
      tx: 'https://live.blockcypher.com/ltc/tx/{txHash}',
    },
  };

  constructor(private sanitizer: DomSanitizer) {}

  public getSafeAddress(coin: string, address: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(this.getAddressLink(coin, address));
  }

  public getSafeTx(coin: string, txHash: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(this.getTxLink(coin, txHash));
  }

  public getAddressLink(coin: string, address: string) {
    return this.getCoin(coin).address.replace('{address}', address);
  }

  public getTxLink(coin: string, txHash: string) {
    return this.getCoin(coin).tx.replace('{txHash}', txHash);
  }

  /**
   * Get coin exploerer of default to ethereum exploerer.
   * @param coin
   */
  public getCoin(coin: string): { address: string; tx: string } {
    return this.links[coin] || this.links.eth;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/explorer-linker.service.ts